import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@appNeo/neoCore/services/loader/loader.service';
import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'neo-menu-dropdown-elem',
  templateUrl: './menu-dropdown-elem.component.html',
  styleUrls: ['./menu-dropdown-elem.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ]),
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('200ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('200ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
    
  ],
})
export class MenuDropdownElemComponent implements OnInit {
  @Input() elemento;

  expanded:boolean =false;

  constructor(
    public router: Router,
    private service: TranslocoService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
  }

  seleccionItemMenu(menuItem) {
    if (menuItem?.codigo) {
      if (!menuItem?.hijos) {
        this.service.setActiveLang(menuItem.codigo);
      }
      
    }
    if (menuItem.urlExterna) {
      if (menuItem?.url && menuItem?.url!='#') {
        window.location.href = menuItem?.url;
      }
    } else {
      // menuItem.path = (menuItem?.pageRouter && PAGINAS_ROUTES[menuItem.pageRouter]) ? PAGINAS_ROUTES[menuItem.pageRouter] : menuItem.path;
      if (menuItem?.path && menuItem.path.length) {
        this.loaderService.setLoading(true);
        setTimeout(() => {
          console.warn("Desactivado loader menu");
          this.loaderService.setLoading(false);
        }, 3000);
        this.router.navigate([menuItem.path]);
      }
    }
    
  }
}
